import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import ProtectedRoute from './ProtectedRoute';

/**
 * AdminRoute - Protects routes that require admin role
 * 
 * Wraps ProtectedRoute to first check authentication,
 * then checks if user has admin role.
 * Non-admins are redirected to dashboard.
 */
const AdminRoute = ({ children }) => {
  const { isAdmin, loading } = useAuth();

  // ProtectedRoute handles authentication check
  // We only need to check admin status here
  return (
    <ProtectedRoute>
      <AdminCheck isAdmin={isAdmin} loading={loading}>
        {children}
      </AdminCheck>
    </ProtectedRoute>
  );
};

/**
 * Inner component to check admin status after authentication
 */
const AdminCheck = ({ children, isAdmin, loading }) => {
  // Still loading role info
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  // Not admin - redirect to dashboard
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
